import React, { useState } from 'react';
import { Card, Form } from 'semantic-ui-react';

import { TxButton } from '../substrate-lib/components';

export default function RegisterProductForm (props) {
  const { accountPair } = props;
  const [status, setStatus] = useState([]);
  const [params, setParams] = useState({ id: null });

  const onChange = (_, data) => {
    const newParams = { ...params };
    if (data.state === 'id') {
      newParams.id = (data.value.length === 0 ? null : data.value);
    }
    setParams(newParams);
  };

  return <Card fluid color = 'blue'>
    <Card.Content style={{ flexGrow: 0 }} header = 'Register an Issuer' />
    <Card.Content>
      <Card.Description>
        <Form>
          <Form.Input
            fluid required
            label='Account ID'
            name='accId'
            state='id'
            onChange={onChange}
          />
          <Form.Field>
            <TxButton
              accountPair={accountPair}
              label='Register'
              type='SUDO-TX'
              style={{ display: 'block', margin: 'auto' }}
              setStatus={setStatus}
              attrs={{
                palletRpc: 'certificateOfOriginV1',
                callable: 'addIssuer',
                inputParams: [params.id],
                paramFields: [true]
              }}
            />
          </Form.Field>
          <div style={{ overflowWrap: 'break-word' }}>{status}</div>
        </Form>
      </Card.Description>
    </Card.Content>
  </Card>;
}
